var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilGreenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4173 6.87885L11.1212 5.58268L2.58333 14.1205V15.4167H3.8795L12.4173 6.87885ZM13.7135 5.58268L15.0097 4.28652L13.7135 2.99035L12.4173 4.28652L13.7135 5.58268ZM4.6385 17.25H0.75V13.3606L13.0654 1.04518C13.2373 0.873334 13.4704 0.776794 13.7135 0.776794C13.9566 0.776794 14.1897 0.873334 14.3616 1.04518L16.9548 3.63843C17.1267 3.81033 17.2232 4.04345 17.2232 4.28652C17.2232 4.52958 17.1267 4.7627 16.9548 4.9346L4.63942 17.25H4.6385Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilGreenIcon);
export default __webpack_public_path__ + "static/media/pencil-green-icon.576aae2a3da5f2aa0b82231dc30382c9.svg";
export { ForwardRef as ReactComponent };